<div [formGroup]="formGroup()" class="form-container">
    <p>WNL: Normocephalic, no lesions or scars. PERRLA, sclera white, conjuntiva pink. Symmetrical, no ear discharge,
        hearing intact. No nose discharge noted. Soft, no lymphadenopathy, trachea midline.
        Mucus membranes moist and pink, no lesions, tonsils not enlarged.</p>
    <mat-checkbox [checked]="wnlManager.allWNL" [indeterminate]="wnlManager.someWNL()"
        (change)="wnlManager.setAllWNL($event.checked)">
        All Within Normal Limits
    </mat-checkbox>

    <div class="head">
        <h2>Head</h2>

        <assessment-row title="Abnormal Shape">
            <emr-input type="text" [hasWNL]="true" [control]="formGroup().controls.headAbnormalShape"
                [default]="abnormalShapeDefault" [(wnl)]="wnlManager.controlColl['abnormalShape'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>

        <assessment-row title="Lesions or Scars">
            <emr-input type="text" [hasWNL]="true" [control]="formGroup().controls.headLesionsOrScars"
                [default]="lesionsOrScarsDefault" [(wnl)]="wnlManager.controlColl['lesionsOrScars'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>

        <assessment-row title="Other">
            <emr-input type="text" [control]="formGroup().controls.headOther" />
        </assessment-row>
    </div>

    <div class="eyes">
        <h2>Eyes</h2>

        <assessment-row title="Pupillary Response">
            <emr-input type="select" [hasWNL]="true" [control]="formGroup().controls.pupillaryResponse"
                [options]="pupillaryResponseOptions" [default]="pupillaryResponseDefault"
                [(wnl)]="wnlManager.controlColl['pupillaryResponse'].wnl" (wnlChange)="wnlManager.updateAllWNL()" />
        </assessment-row>

        <h2>Pupillary Dilation</h2>
        <div class="sensation">
            <emr-input type="select" [hasWNL]="true" label="Left" [control]="formGroup().controls.leftPupillaryDilation"
                [options]="pupillaryDilationOptions" [default]="pupillaryDilationDefault"
                [(wnl)]="wnlManager.controlColl['leftPupillaryDilation'].wnl" (wnlChange)="wnlManager.updateAllWNL()"
                [bottomSpace]="true" />
            <emr-input type="select" [hasWNL]="true" label="Right"
                [control]="formGroup().controls.rightPupillaryDilation" [options]="pupillaryDilationOptions"
                [default]="pupillaryDilationDefault" [(wnl)]="wnlManager.controlColl['rightPupillaryDilation'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()" [bottomSpace]="true" />
        </div>

        <assessment-row title="Sclera Yellow?">
            <emr-checkbox [control]="formGroup().controls.scleraYellow" label="Yes" />
        </assessment-row>

        <assessment-row title="Conjunctiva Pale?">
            <emr-checkbox [control]="formGroup().controls.conjunctivaPale" label="Yes" />
        </assessment-row>

        <assessment-row title="Conjunctiva Red?">
            <emr-checkbox [control]="formGroup().controls.conjunctivaRed" label="Yes" />
        </assessment-row>

        <assessment-row title="Other">
            <emr-input type="text" [control]="formGroup().controls.eyesOther" />
        </assessment-row>
    </div>

    <div class="ears">
        <h2>Ears</h2>

        <assessment-row title="Asymmetrical?">
            <emr-checkbox [control]="formGroup().controls.earsAsymmetrical" label="Yes" />
        </assessment-row>

        <assessment-row title="Hearing Impaired">
            <emr-input type="text" [hasWNL]="true" [control]="formGroup().controls.hearingImpaired"
                [default]="hearingImpairedDefault" [(wnl)]="wnlManager.controlColl['hearingImpaired'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>
        @if (formGroup().controls.hearingImpaired.enabled) {
        <h2>Hearing Aids</h2>
        <div class="hearingAid">
            <assessment-row title="Left">
                <emr-checkbox [control]="formGroup().controls.hearingAidLeft" label="Yes"></emr-checkbox>
            </assessment-row>
            <assessment-row title="Right">
                <emr-checkbox [control]="formGroup().controls.hearingAidRight" label="Yes"></emr-checkbox>
            </assessment-row>
        </div>
        }

        <assessment-row title="Discharge Present">
            <emr-input type="text" [hasWNL]="true" [control]="formGroup().controls.earsDischargePresent"
                [default]="earDischargePresentDefault" [(wnl)]="wnlManager.controlColl['earDischargePresent'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>

        <assessment-row title="Other">
            <emr-input type="text" [control]="formGroup().controls.earsOther" />
        </assessment-row>
    </div>

    <div class="nose">
        <h2>Nose</h2>
        <assessment-row title="Obstructed Nares">
            <emr-input type="text" [hasWNL]="true" [control]="formGroup().controls.obstructedNares"
                [default]="obstructedNaresDefault" [(wnl)]="wnlManager.controlColl['obstructedNares'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>

        <assessment-row title="Discharge Present">
            <emr-input type="text" [hasWNL]="true" [control]="formGroup().controls.noseDischargePresent"
                [default]="noseDischargePresentDefault" [(wnl)]="wnlManager.controlColl['noseDischargePresent'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>
    </div>

    <div class="neck">
        <h2>Neck</h2>

        <assessment-row title="Firm to Touch">
            <emr-input [hasWNL]="true" [control]="formGroup().controls.neckFirmToTouch" [default]="firmToTouchDefault"
                [(wnl)]="wnlManager.controlColl['firmToTouch'].wnl" (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>

        <assessment-row title="Stiff Neck">
            <emr-input [hasWNL]="true" [control]="formGroup().controls.stiffNeck" [default]="stiffNeckDefault"
                [(wnl)]="wnlManager.controlColl['stiffNeck'].wnl" (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>

        <assessment-row title="Enlarged Lymph Nodes">
            <emr-input [hasWNL]="true" [control]="formGroup().controls.enlargedLymphNodes"
                [default]="enlargedLymphNodesDefault" [(wnl)]="wnlManager.controlColl['enlargedLymphNodes'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>

        <assessment-row title="Deviated Trachea">
            <emr-input [hasWNL]="true" [control]="formGroup().controls.deviatedTrachea"
                [default]="deviatedTracheaDefault" [(wnl)]="wnlManager.controlColl['deviatedTrachea'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>
    </div>

    <div class="throat">
        <h2>Throat/Mouth</h2>

        <assessment-row title="Dry Mucus Membranes">
            <emr-checkbox [control]="formGroup().controls.throatDryMucusMembranes" label="Yes" />
        </assessment-row>

        <assessment-row title="Lesions Present">
            <emr-input [hasWNL]="true" [control]="formGroup().controls.throatLesionsPresent"
                [default]="lesionsPresentDefault" [(wnl)]="wnlManager.controlColl['lesionsPresent'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>

        <assessment-row title="Enlarged Tonsils">
            <emr-input [hasWNL]="true" [control]="formGroup().controls.enlargedTonsils"
                [default]="enlargedTonsilsDefault" [(wnl)]="wnlManager.controlColl['enlargedTonsils'].wnl"
                (wnlChange)="wnlManager.updateAllWNL()"></emr-input>
        </assessment-row>
    </div>
</div>